import IParsedSearchParams from '../types/IParsedSearchParams'

const defaultSearchParams = (): IParsedSearchParams => {
    return {
        bgColor: '#FFFFFF',
        nowPlayingBgColor: '#F2F2F2',
        playColor: '#039BE5',
        seekbarColor: '#039BE5',
        textColor: '#000000',
    }
}

export const parseSearchParams = (searchParams: URLSearchParams): IParsedSearchParams => {
    const defaultParams = defaultSearchParams()

    return {
        bgColor: searchParams.get('bgColor') || defaultParams.bgColor,
        nowPlayingBgColor: searchParams.get('nowPlayingBgColor') || defaultParams.nowPlayingBgColor,
        playColor: searchParams.get('playColor') || defaultParams.playColor,
        seekbarColor: searchParams.get('seekbarColor') || defaultParams.seekbarColor,
        textColor: searchParams.get('textColor') || defaultParams.textColor,
        publisherCode: searchParams.get('publisherCode') || undefined,
        articleList: searchParams.get('articleList') || undefined,
    }
}
export const isArticleWidget = () => {
    return window.location.pathname === '/v1/article'
}
